<script setup lang="ts">
// The standalone Full guide is retired (req 1): everything that affects
// what a user uploads now lives on the create page itself. This route
// only survives to catch old links and bookmarks.
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'

// Named so the layout's KeepAlive can exclude this page by name
// (volatile detail/checkout data must not be served from cache).
defineOptions({ name: 'AvatarMaterialGuideRedirectPage' })
definePage({ meta: { desktopAvatarFallback: '/avatars/custom' } })

const router = useRouter()

onMounted(() => {
  router.replace({ path: '/avatars/create' })
})
</script>

<template>
  <div />
</template>
